export const lightColorsTMS = {
  main: '#FDD32A',
  main_light: '#FFE880',
  main_dark: '#F0BE0C',
  system_gray: '#CFD6DC',
  white: '#FFFFFF',
  bg_gray: '#F4F5F7',
  additional_gray: '#E9EAEE',
  gray: '#ACB1B6',
  // ТЗ 0039, доводка UX. Было #76777C: 4.47:1 на белом и всего 4.10 на
  // карточке bg_gray (#F4F5F7) при норме 4.5. Это ЕДИНСТВЕННЫЙ токен
  // вторичного текста, поэтому недобор попадал на каждый экран ЛМС — подписи
  // полей, счётчики, сноски. #6B6C71 даёт 5.24 на белом и 4.80 на карточке.
  // Тёмная тема не трогается: там gray_dark = #B0B5BC, то есть 8.9 и 8.1.
  gray_dark: '#6B6C71',
  black: '#070707',
  btn_text: '#070707',
  btn_hover_text: '#070707',
  signal_red: '#E82B27',
  signal_green: '#37AB34',
  marker_green: '#0E6245',
};

export const darkColorsTMS = {
  main: '#FDD32A',
  main_light: '#BFA820',
  main_dark: '#D4A90A',
  system_gray: '#3A3F44',
  white: '#141414',
  bg_gray: '#1E1E1E',
  additional_gray: '#2C2C30',
  gray: '#8B9099',
  gray_dark: '#B0B5BC',
  black: '#ECECEC',
  btn_text: '#070707',
  btn_hover_text: '#070707',
  signal_red: '#FF4D4A',
  signal_green: '#45D142',
  marker_green: '#12B577',
};

export const lightColorsLearnIT = {
  main: '#FFDF17',
  main_light: '#FFE880',
  main_dark: '#F0C015',
  system_gray: '#CFD6DC',
  white: '#FFFFFF',
  bg_gray: '#F4F5F7',
  additional_gray: '#E9EAEE',
  gray: '#ACB1B6',
  gray_dark: '#6B6C71',
  black: '#222222',
  btn_text: '#222222',
  btn_hover_text: '#222222',
  signal_red: '#E82B27',
  signal_green: '#37AB34',
  marker_green: '#0E6245',
};

export const darkColorsLearnIT = {
  main: '#FFDF17',
  main_light: '#BFA820',
  main_dark: '#D4A90A',
  system_gray: '#3A3F44',
  white: '#141414',
  bg_gray: '#1E1E1E',
  additional_gray: '#2C2C30',
  gray: '#8B9099',
  gray_dark: '#B0B5BC',
  black: '#ECECEC',
  btn_text: '#222222',
  btn_hover_text: '#222222',
  signal_red: '#FF4D4A',
  signal_green: '#45D142',
  marker_green: '#12B577',
};
